import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("raw_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const setAdminToken = (token) => {
  if (token) localStorage.setItem("raw_admin_token", token);
  else localStorage.removeItem("raw_admin_token");
};

export const getAdminToken = () => localStorage.getItem("raw_admin_token");
